import * as keyapis_event_v1_event_pb from "./v1/keyapis_event_event_v1.pb";
import * as keyapis_event_v1_events_pb from "./v1/keyapis_event_events_v1.pb";

export default {
  v1: {
    resources: {
      event: keyapis_event_v1_event_pb,
      events: keyapis_event_v1_events_pb,
    },
  },
};
